import Avatar from 'components/Avatar/Avatar';

export default Avatar;
